module.exports = __webpack_public_path__ + "img/PlatformFeature.898fd620.jpg";